import { FieldValues, useForm, UseFormReturn } from 'react-hook-form';
import { HookedForm } from '../HookedForm';
import { DateRangePicker } from '../DateRangePicker/DateRangePicker';
import { FilterDropdown } from '../FilterDropdown';
import MailBoxIcon from '@app/assets/icons/mail-box.svg?react';
import IPhoneIcon from '@app/assets/icons/iphone.svg?react';
import MailOpenIcon from '@app/assets/icons/mail-04.svg?react';
import {AUTOMATION_STATUS_VALUE, AutomationStatusType} from '@app/models/automations.ts';
import {getAutomationStatusColor} from "@app/utils/utils.tsx";
import {startCase} from "lodash";

export const AutomationsFilters = ({
  filterForm,
  showReset = false,
  onReset,
}: {
  filterForm?: UseFormReturn<FieldValues>;
  showReset?: boolean;
  onReset?: () => void;
}) => {
  const formHook = useForm();
  const activeForm = filterForm ?? formHook;
  const statusesOptions = [
      {
          // label: 'Paused',
          value: AUTOMATION_STATUS_VALUE.PAUSED,
      },
      {
          value: AUTOMATION_STATUS_VALUE.ACTIVE,
      },
      {
          value: AUTOMATION_STATUS_VALUE.COMPLETED,
      },
      {
          value: AUTOMATION_STATUS_VALUE.CANCELLED,
      },
      {
          value: AUTOMATION_STATUS_VALUE.DRAFT,
      },
  ].map((statusOption: {value: AutomationStatusType, label?: string}) => ({
      ...statusOption,
      label: statusOption.label ?? startCase(statusOption.value.toLowerCase()),
      icon: <div className="w-2 h-2 rounded-full" style={{ backgroundColor: getAutomationStatusColor(statusOption.value) }}></div>
  }));


  return (
    <div>
      <HookedForm
        formHook={activeForm}
        mode="onChange"
        className="flex gap-4 flex-col md:flex-row items-center"
      >
        <DateRangePicker
          startName="from"
          endName="to"
          startPlaceholder="Start date"
          endPlaceholder="End date"
          className="bg-gray-100 border-0 rounded-lg px-4 py-2 text-gray-600 placeholder:text-gray-500 focus:bg-gray-200 focus:outline-none"
          containerClass="flex-shrink-0"
          position="absolute"
        />
        
        <FilterDropdown
          name="channels"
          placeholder="All channels"
          options={[
            { label: 'Email', value: 'email', icon: <MailBoxIcon /> },
            { label: 'Text', value: 'sms', icon: <IPhoneIcon /> },
            { label: 'Email & Text', value: 'all', icon: <MailOpenIcon /> },

          ]}
          formHook={activeForm}
          multiSelect={true}
        />

        <FilterDropdown
          name="statuses"
          placeholder="All statuses"
          options={statusesOptions}
          formHook={activeForm}
          multiSelect={true}
        />

        {/* Reset Filter Button */}
        {showReset && (
          <button
            type="button"
            onClick={onReset}
            className="flex items-center gap-1 text-red-500 hover:text-red-600 transition-colors cursor-pointer"
          >
            <span className="text-sm">Reset</span>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 4L4 12M4 4L12 12"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        )}
      </HookedForm>
    </div>
  );
};
